export default __webpack_public_path__ + "static/media/feature-link.1bb7d06d.webp";